import ProcessingOrdersApi from "@/services/processing-orders-api";
import OrderAPI from "@/services/orders-api";

export const namespaced = true;

export const state = {
    cart: null,
    isLoadingCart: false,
    submitOrderInProgress: false,
    orderSubmited: false,
    orderFailed: false,
};

export const mutations = {

  SET_CART(state, cart) {

    if (cart && cart.menuCode && cart.tableNumber) {
      state.cart = cart;
    } else {
      state.cart = null; 
    }
  },

  SET_LOADING_CART(state, isLoading) {
    state.isLoadingCart = isLoading;
  },

  SET_SUBMIT_ORDER_IN_PROGRESS(state, status) {
    state.submitOrderInProgress = status;
  },

  SET_ORDER_SUBMITED(state, value) {
    state.orderSubmited = value;
  },

  SET_ORDER_FAILED(state, value) {
    state.orderFailed = value;
  }

};


export const actions = {

    setOrderSubmited({ commit }) {
      commit('SET_ORDER_SUBMITED', true);
      setTimeout(() => commit('SET_ORDER_SUBMITED', false), 2500);
    },

    setOrderFailed({ commit }) {
      commit('SET_ORDER_FAILED', true);
      setTimeout(() => commit('SET_ORDER_FAILED', false), 2200);
    },

    async fetchCart({ commit, rootState }) {

      commit('SET_CART', null);
      commit('SET_LOADING_CART', true);

      try {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');
        
        const location = rootState.location?.location;
        const lat =  location?.latitude ?? null;
        const lng =  location?.longitude ?? null;

        const response = await ProcessingOrdersApi.get(menuCode, lat, lng, tid, ts, did);
        if (response?.status === 200 && response.data) {
          commit('SET_CART', response.data);
        }
      } catch (error) {
        console.error("Erreur fetchCart:", error);
      } finally {
        commit('SET_LOADING_CART', false);
      }
    },


    addNoteToOrderLine({ commit }, addNoteToOrderLineRequest) {

      return new Promise((resolve, reject) => {

        ProcessingOrdersApi.addNote(addNoteToOrderLineRequest.orderLineId ,addNoteToOrderLineRequest.note)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              const cart = response.data;
              commit('SET_CART', cart);
              resolve(cart);
            } else {
              reject(new Error('Add to cart failed'));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },


    addToOrder({ commit, rootState  }, addToOrderRequestList) {
      return new Promise((resolve, reject) => {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');

        const location = rootState.location?.location;
        const latitude = location?.latitude ?? null;
        const longitude = location?.longitude ?? null;

        ProcessingOrdersApi.add(menuCode, tid, ts, addToOrderRequestList, latitude, longitude, did)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              const cart = response.data;
              commit('SET_CART', cart);
              resolve(cart);
            } else {
              reject(new Error('Add to cart failed'));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    removeFromOrder({commit}, orderLineId) {
      return new Promise((resolve, reject) => {

        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');

            if (!orderLineId) {
              return;
            }

            ProcessingOrdersApi.remove(menuCode, tid, ts, orderLineId, did).then(
              (response)=> {
                if (response && response.status == 200) {
                    const cart = response.data;
                    commit('SET_CART', cart);
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            })
        });
    },


  checkoutOrder({ commit, state, rootState, dispatch }, request) {
    return new Promise((resolve, reject) => {
      const url = new URL(window.location.href);
      const pathSegments = url.pathname.split('/');
      const menuCode = pathSegments[pathSegments.length - 1];
      const tid = url.searchParams.get('tid');
      const did = url.searchParams.get('did');
      const ts = url.searchParams.get('ts');

      const location = rootState.location?.location;
      request.latitude = location?.latitude ?? null;
      request.longitude = location?.longitude ?? null;

      request.orderId = state.cart == null ? null : state.cart.id;

      request.menuCode = menuCode;
      request.tableNumber = tid;
      request.ts = ts;
      request.did = did;

      commit('SET_SUBMIT_ORDER_IN_PROGRESS', true);


      OrderAPI.submitOrder(request)
        .then((response) => {
          if (response && response.status === 200) {
            const cart = response.data;
            commit('SET_CART', cart);
            dispatch('setOrderSubmited');
            resolve(cart);
          } else {
            reject(new Error('Order submission failed'));
          }
        })
        .catch((error) => {

          const status = error?.status;
          if (status === 428) {
            reject(error);
            return;
          }
          reject(error);
          dispatch('setOrderFailed');
          dispatch('fetchCart');
        })
        .finally(() => {
          commit('SET_SUBMIT_ORDER_IN_PROGRESS', false);
        });
    });
  }


};

export const getters = {
  cart: (state) => state.cart,
  isLoadingCart: (state) => state.isLoadingCart,
  submitOrderInProgress: (state) => state.submitOrderInProgress,
  orderSubmited: (state) => state.orderSubmited,
  orderFailed: (state) => state.orderFailed,
};
